import React, { useState } from 'react';
import SectionEdition, { Slot } from 'components/styleguide/section_edition/SectionEdition';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import Textarea from 'components/styleguide/textarea/Textarea';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

interface AboutUsSectionProps {
  description: string;
  url: string;
  errors?: Record<string, string>;
}

const AboutUsSection: React.FC<AboutUsSectionProps> = ({
  description: initialDescription,
  url,
  errors,
}) => {
  const [display, setDisplay] = useState({
    description: initialDescription || '',
  });

  const sheet = useEditableSheet({
    url,
    payloadKey: 'company',
    onSuccess: (data) => {
      setDisplay({
        description: data.description || '',
      });
    },
  });

  const handleEditClick = (action: string) => {
    if (action === 'edit') {
      sheet.open('Edit about us', {
        description: display.description,
      });
    } else if (action === 'add') {
      sheet.open('Add about us', {
        description: '',
      });
    }
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    sheet.handleFormChange(e.target.name, e.target.value);
  };

  const dataFilled = display.description.trim();
  const status = dataFilled ? 'complete' : errors?.description ? 'mandatory' : 'missing';

  return (
    <>
      <SectionEdition
        title="About us"
        iconName="fileText"
        context="company"
        status={status}
        onAdd={() => handleEditClick("add")}
        onEdit={() => handleEditClick("edit")}
      >
        {dataFilled && (
          <Slot>
            <p className={styles.description}>{display.description}</p>
          </Slot>
        )}
      </SectionEdition>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="company"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <div className={styles.form}>
            <Textarea
              label='Your company bio'
              name="description"
              placeholder="Share what makes your company unique"
              required={true}
              className={styles.questionTextarea}
              defaultValue={sheet.formData.description || ''}
              onChange={handleTextareaChange}
              rows={6}
              maxLength={2000}
              showCharacterCount
              error={sheet.getError('description')}
              context="company"
            />
          </div>
        </Sheet>
      )}
    </>
  );
};

export default AboutUsSection;
